import { useContext, useEffect } from 'react';
import { ProdutoContext } from '../../../../context/product';
import ReactSelect from '../../../data/reactSelect';
import { InputDefault } from '../../../data/inputDefault';
import Layout from '../../../data/Layout';
import { useAppSelector } from '../../../../redux/store';
import Globals from '../../../../Globals.json';

import * as S from '../styled';
import { useQueryFetchPages } from '../../../../apiQuery/useQueryFetchPages';

export default function InfoEstoque({ isEdit }: { isEdit: any; isDupli: any }) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const {
    data: measure,
    isLoading: isLoadingMeasure,
    isError: isErrorMeasure,
  } = useQueryFetchPages<any>(['measure'], `${Globals.api.measure}`, {
    queryParams: {
      store_id: storeMe?.storeActive?.id,
      paginate: false,
    },
  });
  const {
    data: stocks,
    isLoading: isLoadingStocks,
    isError: isErrorStocks,
  } = useQueryFetchPages<any>(['stocks'], `${Globals.api.stocks}`, {
    queryParams: {
      store_id: storeMe?.storeActive?.id,
      paginate: false,
    },
  });
  const {
    unit,
    currentAmount,
    setCurrentAmount,
    minAmount,
    setMinAmount,
    localStock,
    setLocalStock,
    unitMeasureBuy,
    setUnitMeasureBuy,
    multiple,
    setMultiple,
    observation,
    setObservation,
    setLocalStockName,
    setStock_uuid,
    validqty,
    validLocalStock,
  } = useContext(ProdutoContext);

  const handlelocalStock = (e: any) => {
    setLocalStock(e?.value);
    setLocalStockName(e?.label);
    setStock_uuid(e?.uuid);
  };

  useEffect(() => {
    if (!localStock) {
      const findStock = stocks?.data?.find(
        (item: any) => item?.name === 'LOCAL PADRÃO'
      );
      setLocalStock(findStock?.id);
      setLocalStockName(findStock?.name);
      setStock_uuid(findStock?.uuid);
    }
  }, [stocks]);

  return (
    <Layout title="Informações de Estoque e Movimentação">
      <S.Wrapper>
        <InputDefault
          label="Qtd. Atual"
          placeholder="0,00"
          type="number"
          autoComplete="off"
          step="0.01"
          min="0"
          state={currentAmount}
          setState={setCurrentAmount}
          disabled={isEdit ? true : false}
          isInvalid={validqty}
        />

        <InputDefault
          label="Qtd.  mínima"
          placeholder="0,00"
          type="number"
          autoComplete="off"
          step="0.01"
          min="0"
          state={minAmount}
          setState={setMinAmount}
        />

        <ReactSelect
          label="Loc. estoque"
          isClearable
          options={stocks?.data?.map((item: any) => ({
            value: item.id,
            label: item.name,
            uuid: item.uuid,
            store_id: item.store_id,
          }))}
          onChange={handlelocalStock}
          state={localStock}
          placeholder="Local de estoque padrão"
          isInvalid={validLocalStock}
          isLoading={isLoadingStocks}
          isDisabled={isLoadingStocks}
        />

        <ReactSelect
          label="Uni. compra"
          isClearable
          options={measure?.data?.map((item: any) => ({
            value: item.id_pdv_measure,
            label: item.name,
            store_id: item.store_id,
          }))}
          state={unitMeasureBuy ? unitMeasureBuy : unit}
          setState={setUnitMeasureBuy}
          placeholder="Unidade de medida na compra"
          isLoading={isLoadingMeasure}
          isDisabled={isLoadingMeasure}
        />

        <InputDefault
          label="Multiplicador"
          placeholder="0,00"
          type="number"
          autoComplete="off"
          step="0.01"
          min="0"
          state={multiple}
          setState={setMultiple}
        />

        <ReactSelect
          label="Uni. venda"
          isClearable
          options={measure?.data?.map((item: any) => ({
            value: item.id_pdv_measure,
            label: item.name,
            store_id: item.store_id,
          }))}
          state={unit}
          setState={''}
          placeholder="Unidade de medida na venda"
          // isDisabled={true}
          isLoading={isLoadingMeasure}
        />

        {/* 
        
        <Col md="4">
          <InputDefault
            label='Locais e Quantidades'
            placeholder="Sem lançamentos de estoque"
            type='text'
            autoComplete='off'
            maxLength={50}
            disabled={true}
          />
        </Col>
        */}

        <InputDefault
          label="Observação"
          placeholder="Informe a referência de estoque"
          type="text"
          autoComplete="off"
          maxLength={255}
          state={observation}
          setState={setObservation}
        />
      </S.Wrapper>
    </Layout>
  );
}
